import { Box, Grid, Typography, useTheme } from "@mui/material";
import { Command } from "~/components/guides/components/command";
import { Markdown } from "~/components/markdown";
import { SCAN_COMMAND, buildPowerShellInstallCommand } from "../utils";

interface PowerShellInstallationStepsProps {
  tokenValue: string;
}

export const PowerShellInstallationSteps = ({
  tokenValue,
}: PowerShellInstallationStepsProps) => {
  const theme = useTheme();
  const installCommand = buildPowerShellInstallCommand(tokenValue);

  return (
    <>
      <Box sx={{ mb: 2 }}>
        <Command
          number={2}
          options={{
            fontSize: { xs: 16 },
            dotColor: theme.palette.background.lightest,
          }}
        >
          Download and install cnspec
        </Command>
      </Box>
      <Box sx={{ pl: 6, mb: 5 }}>
        <Typography variant="body1" color="text.secondary" sx={{ mb: 1 }}>
          Run this PowerShell script to download and install cnspec
          automatically.
        </Typography>
        <Markdown source={`\`\`\`powershell\n${installCommand}\n\`\`\``} />
      </Box>

      <Box sx={{ mb: 2 }}>
        <Command
          number={3}
          options={{
            fontSize: { xs: 16 },
            dotColor: theme.palette.background.lightest,
          }}
        >
          Use cnspec to scan your Windows host
        </Command>
      </Box>
      <Box sx={{ pl: 6 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <Markdown source={`\`\`\`bash\n${SCAN_COMMAND}\n\`\`\``} />
        </Grid>
      </Box>
    </>
  );
};
